const mapSortColumn = (data) => data.map(item => {
    let studFeeValue;
    if (item.private_flag) {
        studFeeValue = 0.1;
    } else {
        studFeeValue = item.stud_fee !== null ? item.stud_fee : 0;
    }

    const studFee = item.exchange_rate !== null ?
        studFeeValue / item.exchange_rate : item.stud_fee;
    const yearToStud = parseInt(item.year_to_stud, 10) ? item.year_to_stud : 0;

    return Object.assign({}, item, {
        stud_fee: studFee,
        year_to_stud: yearToStud
    });
});

export default mapSortColumn;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/ColumnSortMapper.js